import moment from 'moment';

export const normalizeDateForApi = (value: moment.MomentInput): Date | null => {
  const date = moment(value);

  if (!date.isValid()) {
    return null;
  }

  return date.hour(12).minute(0).second(0).millisecond(0).toDate();
};

export const formatDateOrEmpty = (value: moment.MomentInput, format = 'DD/MM/YYYY') => {
  const date = moment(value);
  return date.isValid() ? date.format(format) : '';
};
